var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSave = function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.4 7.6-4.9-4.9c-.6-.6-1.4-1-2.3-1H4.9C3.1 1.7 1.7 3.2 1.7 5v22c0 1.8 1.5 3.3 3.3 3.3h22.1c1.8 0 3.3-1.5 3.3-3.3V9.9c-.1-.9-.4-1.7-1-2.3m-18.7 5.6V5.5h10.1v7.7zm15.9-3.1v16.5H5.4V5.5h1.9l.1 9.6c0 .6 0 1.9 1.3 1.9h13.8c1 0 1.9-.8 1.9-1.9V8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 6.6c-.9 0-1.6.6-1.6 1.3v2.9c0 .7.7 1.3 1.6 1.3s1.6-.6 1.6-1.3V7.9c0-.7-.7-1.3-1.6-1.3"
  })));
};
export default SvgSave;